export enum ComplyAdvantageStatus {
    Active = 'active',
    Inactive = 'inactive',
    Unknown = 'unknown',
    Dissolved = 'dissolved',
    Failed = 'failed',
}
